export default __webpack_public_path__ + "static/card-image-1-d34fdfdd38cb80d9c89f8825084d9107.jpg";